import { Button, Chip, TextField, Typography } from '@mui/material'
import IconStyle from 'components/SocialMediaIcon/Style'
import { Colors } from 'constants/colors'
import React from 'react'

interface AnalyzeCreatorsInitialProps {
  onSubmit: any
  creators: string[]
  setCreators: React.Dispatch<React.SetStateAction<string[]>>
  refetch: any
}

export default function AnalyzeCreatorsInitial(
  props: AnalyzeCreatorsInitialProps
): JSX.Element {
  const { onSubmit, creators, setCreators, refetch } = props
  const [fieldValue, setFieldValue] = React.useState<string>('')
  const addCreatorToList = (): void => {
    if (!creators.includes(fieldValue.toLocaleLowerCase())) {
      setCreators((prev) => [...prev, fieldValue.toLowerCase().trim()])
      setFieldValue('')
    }
  }
  return (
    <div style={{ color: 'white' }}>
      <h2
        style={{
          margin: '20px 0 0',
          padding: 0,
          color: 'white',
        }}
      >
        Analyze creators
      </h2>
      <p
        style={{
          fontSize: '14px',
          fontWeight: 400,
          color: Colors.darkCoolGray,
          opacity: 0.7,
          margin: '0 0 100px',
          padding: 0,
        }}
      >
        To unlock comprehensive insights, input the usernames of three Instagram
        accounts you wish to analyze. Please ensure these accounts are set to
        public, as private accounts restrict our ability to provide detailed
        analysis. Get ready to explore and understand your chosen creators on a
        whole new level.
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 15vw',
        }}
      >
        <TextField
          id="standard-basic"
          label="Add Creator"
          variant="outlined"
          fullWidth
          value={fieldValue}
          disabled={creators.length > 2}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              addCreatorToList()
            }
          }}
          onChange={(e) => {
            setFieldValue(e.target.value)
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              color: 'white',
              '& fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.23)',
              },
              '&:hover fieldset': {
                borderColor: 'rgba(255, 255, 255, 0.5)',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
              },
              '&.Mui-disabled': {
                color: 'rgba(255, 255, 255, 0.3)',
                '& fieldset': {
                  borderColor: 'rgba(255, 255, 255, 0.1)',
                },
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
              },
            },
            '& .MuiInputLabel-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              '&.Mui-focused': {
                color: 'primary.main',
              },
              '&.Mui-disabled': {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
          }}
        />
        <Button
          disabled={creators.length > 2}
          variant="contained"
          onClick={() => {
            addCreatorToList()
          }}
          sx={{
            height: '56px',
            padding: '6px 26px',
            '&.Mui-disabled': {
              color: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        >
          Add
        </Button>
      </div>
      <div
        style={{
          backgroundColor: Colors.backgroundDark,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          padding: '40px',
          borderRadius: '20px',
          margin: '100px auto 0 auto',
          maxWidth: '800px',
          color: 'white',
        }}
      >
        <Typography
          sx={{
            fontSize: '22px',
            fontWeight: 700,
            color: 'white',
          }}
        >
          Accounts:
        </Typography>
        <div style={{ display: 'flex', gap: '20px' }}>
          {creators.length ? (
            creators.map((creator) => {
              return (
                <Chip
                  key={creator}
                  label={creator}
                  onDelete={() => {
                    setCreators((prev) => [
                      ...prev.filter((x) => x !== creator),
                    ])
                  }}
                  icon={
                    <IconStyle.InstagramIconStyle
                      style={{
                        color: Colors.pink,
                      }}
                    />
                  }
                  variant="outlined"
                  sx={{
                    borderColor: Colors.pink,
                    backgroundColor: 'rgba(226, 4, 120, 0.1)',
                    fontWeight: 700,
                    fontSize: '16px',
                    color: 'white',
                    padding: '10px 20px',
                    '& .MuiChip-deleteIcon': {
                      color: Colors.pink,
                      ':hover': {
                        color: '#b40360',
                      },
                    },
                  }}
                />
              )
            })
          ) : (
            <p
              style={{
                fontStyle: 'italic',
                color: Colors.darkDeepGray,
              }}
            >
              Currently, no accounts have been added, please add the desired
              accounts.
            </p>
          )}
        </div>
        <Button
          disabled={creators.length !== 3}
          variant="contained"
          onClick={() => {
            onSubmit()
              .then(() => {
                refetch()
              })
              .catch(() => {
                refetch()
              })
          }}
          sx={{
            fontSize: '18px',
            padding: '6px 36px',
            marginTop: '20px',
            borderRadius: '30px',
            backgroundColor: Colors.pink,
            ':hover': {
              backgroundColor: '#b40360',
            },
            '&.Mui-disabled': {
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              color: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        >
          Analyze
        </Button>
      </div>
    </div>
  )
}
